import React from "react";
import { Helmet } from "react-helmet";

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keyword" content={keywords} />
    </Helmet>
  );
};

Meta.defaultProps = {
  title: "برنامج العيادة",
  description:
    "برنامج العيادة كلينيكال: الحل الأمثل لإدارة العيادات الطبية، يشمل إدارة المواعيد، سجلات المرضى، الفواتير، والتقارير بسهولة وفعالية ",
  keywords: "برنامج العيادة المجاني",
};

export default Meta;
